import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'apadavi'
})
export class ApadaviPipe implements PipeTransform {

  transform(value: any[], dato: string): any[] {
    let newArr=value.filter((val) =>  val.apadavi_nombre.toLocaleLowerCase().indexOf(dato.toLocaleLowerCase())>-1 
    || val.apadavi_descripcion.toLocaleLowerCase().indexOf(dato.toLocaleLowerCase())>-1 )

    return newArr;
  }

}
